export default __webpack_public_path__ + "static/media/glp_icon.2c6aa73f.svg";